

























































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import CategoryCard from "@/components/domains/esthe/soundesthe/CategoryCard.vue";
import FieldData from "@/components/infrastructures/functions/fieldData";
import httpResource from "@/components/infrastructures/functions/http/httpResource";
import NatureSoundItemCard
  from "@/components/domains/esthe/soundesthe/plans/categories/naturesound/NatureSoundItemCard.vue";

@Component({
  components: {NatureSoundItemCard, CategoryCard}
})
export default class ExCategoryCard extends Vue {
  name = "PurposeCard.vue";

  @Prop() img!: string;
  @Prop() title!: string;
  @Prop() subtitle!: string;
  @Prop() soundListUrl!: string;
  @Prop({default: false}) disable!: boolean;
  @Prop({default: false}) defaultShow!: boolean;
  @Prop({default: false}) opened!: boolean;

  // mst
  tags: {}[] = [];
  selectedTags: {}[] = [];

  // field
  slctGenres = new FieldData()
      .withType("select");

  // items
  searchedItems: {}[] = [];
  soundItems: {}[] = [];
  beforeIndex = -1;
  selectIndex = 0;

  // event
  attachedEventListener = false;
  stTouchX = 0;
  edTouchX = 0;

  // arrow
  disableArrow = false;

  beforeMount() {
    this.fetchMst();
  }

  created() {
    this.fetchSoundList();
  }

  fetchSoundList() {
    httpResource.get(this.soundListUrl)
        .then((response: any) => {
          this.soundItems = response.data;
          this.searchedItems = this.soundItems;
        })
  }

  fetchMst() {
    httpResource.get("/api/sound-dmv/sound-dmv-mst")
        .then((response: any) => {
          // this.tags = response.data.tags;
          this.slctGenres.withSelection(response.data.genres);
        });
  }

  clickNext() {
    const newIndex = this.selectIndex + 1;
    if (newIndex < this.searchedItems.length) {
      this.selectIndex = newIndex;
    } else {
      this.selectIndex = 0;
    }
  }

  clickBack() {
    const newIndex = this.selectIndex - 1;
    if (newIndex >= 0) {
      this.selectIndex = newIndex;
    } else {
      this.selectIndex = this.searchedItems.length - 1;
    }
  }

  clickSlideBtn(index: number) {
    this.selectIndex = index;
  }

  tagColor(tag: {}) {
    const contains = this.selectedTags.indexOf(tag) !== -1;
    if (contains) {
      return "secondary";
    }
    return "default";
  }

  selectTag(tag: any) {
    const contains = this.selectedTags.indexOf(tag) !== -1;
    if (contains) {
      this.selectedTags = this.selectedTags.filter((n: any) => n.value !== tag.value);
    } else {
      this.selectedTags = this.selectedTags.concat(tag);
    }
  }

  containsAllTag(tags1: string[], tags2: string[]) {
    for (const index in tags1) {
      if (tags2.indexOf(tags1[index]) !== -1) {
        return true;
      }
    }
    return false;
  }

  updateSearchedItems() {
    if (this.selectedTags.length === 0) {
      this.searchedItems = this.soundItems;
      return;
    }
    this.searchedItems = this.soundItems.filter((item: any) => {
      return this.containsAllTag(this.selectedTags.map((t: any) => t.text), item.tags);
    })
  }

  startedAction() {
    this.disableArrow = true;
  }

  stoppedAction() {
    this.disableArrow = false;
  }

  get getSearchedItems() {
    return this.searchedItems;
  }

  @Watch("selectedTags")
  watchSelectedTags() {
    this.updateSearchedItems();
  }
}
